module.exports = [
    { "label": "Booking Enquiry", "value": "Booking Enquiry" },
    // { "label": "Missing Response", "value": "Missing Bot Response" },
    { "label": "Query", "value": "Query" },
    { "label": "New Appointment", "value": "New Appointment" },
    { "label": "Cancel Appointment", "value": "New Appointment" },
    { "label": "Change Appointment", "value": "Change Appointment" },
]